/* global window */
import store from '../reducers/storeRegistration';
import notificationActions from '../actions/notificationActionCreators';
const CABINET_CSV_EXPORT_CONFIRM_MODAL_ID = 'cabinet_csv_export_confirm';
const buildCountMessage = function buildCountMessage() {
  let counts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let totalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const lines = counts.map(item => "\u2022 ".concat(item.formTypeName || item.formTypeIdentifier, ": ").concat(item.count));
  return ['Export the following forms to CSV?', ...lines, '', "Total: ".concat(totalCount)].join('\n');
};
const showExportConfirmationModal = message => new Promise(resolve => {
  const dismissAndResolve = shouldExport => {
    store.dispatch(notificationActions.dismiss(CABINET_CSV_EXPORT_CONFIRM_MODAL_ID));
    resolve(shouldExport);
  };
  store.dispatch(notificationActions.block({
    id: CABINET_CSV_EXPORT_CONFIRM_MODAL_ID,
    headerMessage: 'Export to CSV',
    message,
    leftButtonLabel: 'Cancel',
    leftButtonAction: async () => dismissAndResolve(false),
    rightButtonLabel: 'Export',
    rightButtonAction: async () => dismissAndResolve(true)
  }, {
    autoClose: false,
    showCloseButton: false
  }));
});
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  try {
    const countResult = await sourceEvaluator({
      type: 'cabinetCsvExportCountBehavior',
      cabinetIdentifier: transientContext === null || transientContext === void 0 ? void 0 : transientContext.cabinetIdentifier
    });
    if (!(countResult !== null && countResult !== void 0 && countResult.success)) {
      await sourceEvaluator({
        type: 'validationErrorBehavior',
        errors: [(countResult === null || countResult === void 0 ? void 0 : countResult.message) || 'Unable to count forms for csv export.']
      });
      return false;
    }
    const hasCounts = Array.isArray(countResult.counts) && countResult.counts.length > 0;
    if (!countResult.totalCount || !hasCounts) {
      await sourceEvaluator({
        type: 'validationErrorBehavior',
        errors: ['No exportable forms were found in this cabinet.']
      });
      return false;
    }
    const confirmMessage = buildCountMessage(countResult.counts, countResult.totalCount);
    const shouldExport = await showExportConfirmationModal(confirmMessage);
    if (!shouldExport) {
      return false;
    }
    store.dispatch(notificationActions.info({
      id: 'cabinet_csv_export_in_progress',
      headerMessage: 'CSV Export',
      message: 'Preparing forms for export, this can take a while for large cabinets...'
    }, {
      autoClose: false
    }));
    const exportResult = await sourceEvaluator({
      type: 'cabinetCsvExportBehavior',
      cabinetIdentifier: transientContext === null || transientContext === void 0 ? void 0 : transientContext.cabinetIdentifier,
      // Keep this explicit so we can add csvExport tags later without changing behavior calls.
      tags: ['csvImport']
    });
    store.dispatch(notificationActions.dismiss('cabinet_csv_export_in_progress'));
    if (!(exportResult !== null && exportResult !== void 0 && exportResult.success) || !exportResult.downloadUrl) {
      await sourceEvaluator({
        type: 'validationErrorBehavior',
        errors: [(exportResult === null || exportResult === void 0 ? void 0 : exportResult.message) || 'CSV export failed. Please try again.']
      });
      return false;
    }
    window.location.href = exportResult.downloadUrl;
    return exportResult;
  } catch (error) {
    store.dispatch(notificationActions.dismiss('cabinet_csv_export_in_progress'));
    await sourceEvaluator({
      type: 'validationErrorBehavior',
      errors: [(error === null || error === void 0 ? void 0 : error.message) || 'CSV export failed. Please try again.']
    });
    return false;
  }
};
export default {
  evaluate
};